var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsThumbsDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H16V16L9 23L7.75 21.75C7.63667 21.63 7.54 21.47 7.46 21.27C7.38 21.07 7.34333 20.88 7.35 20.7V20.35L8.45 16H3C2.46667 16 2 15.8 1.6 15.4C1.2 15 1 14.5333 1 14V12C1 11.88 1.01333 11.7533 1.04 11.62C1.06667 11.4867 1.10333 11.36 1.15 11.24L4.15 4.19C4.30333 3.86333 4.55333 3.58333 4.9 3.35C5.24667 3.11667 5.61333 3 6 3ZM18 16V3H22V16H18Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsThumbsDownFilled);
export default __webpack_public_path__ + "static/media/icons_thumbs_down_filled.ff819d1e.svg";
export { ForwardRef as ReactComponent };